import React, { useEffect } from "react";
import "../style/Tabs.css";
import PontajTehnician from "./PontajTehnician";
import Validare from "./Validare";
import IstoricSalariiPontajTehnician from "./IstoricSalariiPontajTehnician";
const TabsPontaje = ({ activeTab, currentUserName, setTab }) => {
  const getCurrentTab = (tab) => {
    switch (tab) {
      case "pontajTehnician":
        return "pontajTehnician";
      case "istoricSalariiTehnician":
        return "istoricSalariiTehnician";
      case "validare":
        return "validare";
      default:
        return "validare";
    }
  };

  const getCurrentScreen = () => {
    switch (activeTab) {
      case "pontajTehnician":
        return <PontajTehnician user={currentUserName} />;
      case "istoricSalariiTehnician":
        return <IstoricSalariiPontajTehnician user={currentUserName} />;
      case "validare":
        return <Validare />;
      default:
        return <Validare />;
    }
  };

  useEffect(() => {
    setTab(getCurrentTab(activeTab));
  }, [activeTab]);

  useEffect(() => {
    if (!currentUserName) {
      setTab("validare");
    }
  }, [currentUserName]);

  return (
    <>
      <div className="tabs_wrapper">
        {currentUserName && <div
          onClick={() => setTab("pontajTehnician")}
          className={
            activeTab === "pontajTehnician" ? "tab_active" : "tab_not_active"
          }
        >
          <p
            className={
              activeTab === "pontajTehnician"
                ? "tab_text_active"
                : "tab_text_not_active"
            }
          >
            Pontaj zilnic
          </p>
        </div>}
        {!currentUserName && <div
          onClick={() => setTab("validare")}
          className={activeTab === "validare" ? "tab_active" : "tab_not_active"}>
          <p
            className={
              activeTab === "validare"
                ? "tab_text_active"
                : "tab_text_not_active"
            }
          >
            Validare pontaj zilnic
          </p>
        </div>}
        {currentUserName && <div
          onClick={() => setTab("istoricSalariiTehnician")}
          className={activeTab === "istoricSalariiTehnician" ? "tab_active" : "tab_not_active"}
        >
          <p
            className={
              activeTab === "istoricSalariiTehnician"
                ? "tab_text_active"
                : "tab_text_not_active"
            }
          >
            Pontaj lunar
          </p>
        </div>}
      </div>
      <div>{getCurrentScreen()}</div>
    </>
  );
};

export default TabsPontaje;
